import { render, staticRenderFns } from "./bill_record.vue?vue&type=template&id=510f0850&scoped=true"
import script from "./bill_record.vue?vue&type=script&lang=js"
export * from "./bill_record.vue?vue&type=script&lang=js"
import style0 from "./bill_record.vue?vue&type=style&index=0&id=510f0850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f0850",
  null
  
)

export default component.exports